import React from 'react';
import { BookOpen, Crosshair, Repeat } from 'lucide-react';
export function AuthoritySection() {
  return <section className="py-16 bg-white border-b border-warm-100" data-id="element-3">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-4">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-charcoal mb-10 leading-tight" data-id="element-5">
          La primera guía diseñada{' '}
          <span className="text-primary" data-id="element-6">
            específicamente para el voltaje y los ingredientes
          </span>{' '}
          de las cocinas colombianas.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-7">
          <div className="flex flex-col items-center text-center" data-id="element-8">
            <div className="bg-warm-50 p-4 rounded-full mb-4 text-primary" data-id="element-9">
              <BookOpen className="w-8 h-8" data-id="element-10" />
            </div>
            <p className="text-charcoal font-medium" data-id="element-11">
              Esto no es "otro recetario de internet": es un{' '}
              <strong className="text-primary" data-id="element-12">protocolo colombiano</strong> con
              tiempos y temperaturas para nuestro contexto.
            </p>
          </div>

          <div className="flex flex-col items-center text-center" data-id="element-13">
            <div className="bg-warm-50 p-4 rounded-full mb-4 text-primary" data-id="element-14">
              <Crosshair className="w-8 h-8" data-id="element-15" />
            </div>
            <p className="text-charcoal font-medium" data-id="element-16">
              Cocinas con un sistema claro:{' '}
              <strong className="text-charcoal" data-id="element-17">
                Corazón Jugoso → Estallido de Sabor
              </strong>
              .
            </p>
          </div>

          <div className="flex flex-col items-center text-center" data-id="element-18">
            <div className="bg-warm-50 p-4 rounded-full mb-4 text-primary" data-id="element-19">
              <Repeat className="w-8 h-8" data-id="element-20" />
            </div>
            <p className="text-charcoal font-medium" data-id="element-21">
              No eres tú contra la Airfryer; eres tú + el{' '}
              <strong className="text-primary" data-id="element-22">
                Mecanismo de Fuego Criollo
              </strong>{' '}
              repitiendo resultados.
            </p>
          </div>
        </div>
      </div>
    </section>;
}